import React from 'react';

import CrudPageLayout from '../../../../layouts/CrudPageLayout';
import DocumentForm from '../DocumentForm';

export default function EditDocument({ loanFileId, loanFile }) {
  return (
    <CrudPageLayout>
      <DocumentForm loanFileId={loanFileId} loanFile={loanFile} />
    </CrudPageLayout>
  );
}
